import {GET_CREDENTIALS} from "@actionTypes/userDataActionType";
import jwt_decode from "jwt-decode";
import {getDefaultRoute, toBoolean} from "@utils/helpers/access";
import {REFUNDS_ROLE} from "@constants/ENV";
import {AUTHORIZED_GROUPS} from "@constants/StorageKeys";

export const getCredential = async (code, navigate, dispatch) => {
    const authorizedGroupNames = Array.isArray(code.authorizedGroupNames)
        ? code.authorizedGroupNames.filter(Boolean)
        : code.authorizedGroupName
            ? [code.authorizedGroupName]
            : [];
    const primaryGroupName = code.authorizedGroupName || authorizedGroupNames[0] || '';
    const canRefund = code.canRefund === undefined
        ? authorizedGroupNames.includes(REFUNDS_ROLE)
        : toBoolean(code.canRefund);

    localStorage.setItem('accessToken', code.accessToken);
    localStorage.setItem('refreshToken', code.refreshToken);
    localStorage.setItem('userName', jwt_decode(code.accessToken).name);
    localStorage.setItem('group', primaryGroupName);
    localStorage.setItem(AUTHORIZED_GROUPS, JSON.stringify(authorizedGroupNames));
    localStorage.setItem('canRefund', String(canRefund));
    window.dispatchEvent( new Event('storage') )
    dispatch({type: GET_CREDENTIALS, payload: code.accessToken})
    navigate(getDefaultRoute({
        authorizedGroupName: primaryGroupName,
        authorizedGroupNames,
        canRefund
    }))
}
